(() => {
  'use strict';

  const status = document.getElementById('rhnow-status');
  const announce = (message) => {
    if (!status || !message) return;
    status.textContent = '';
    window.setTimeout(() => { status.textContent = message; }, 50);
  };

  // Mark the current navigation link for screen readers.
  document.querySelectorAll('a[href]').forEach((link) => {
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search) {
        link.setAttribute('aria-current', 'page');
      }
    } catch (_) {}
  });

  // Announce cart-count changes without interfering with Xtra's own cart scripts.
  const counts = [...document.querySelectorAll('#cart-count, #cart-count--m')];
  counts.forEach((count) => {
    let previous = count.textContent.trim();
    const observer = new MutationObserver(() => {
      const next = count.textContent.trim();
      if (next !== previous) {
        previous = next;
        announce(`Cart updated. ${next || '0'} items.`);
      }
    });
    observer.observe(count, { childList: true, subtree: true, characterData: true });
  });

  // Give icon-only buttons a dependable accessible name when title text exists.
  document.querySelectorAll('button[title]:not([aria-label])').forEach((button) => {
    button.setAttribute('aria-label', button.getAttribute('title'));
  });
})();
